import {Button, ButtonProps as BaseButtonProps, extendVariants, Tooltip, useButton} from "@heroui/react";
import {Icon} from "@iconify/react";

import React, {forwardRef} from "react";
import {useGlobalModal} from "../core/GlobalModal.tsx";
import {useSubscription} from "../hooks/useSubscription.ts";
import PaywallWrapper from "../user/PaywallWrapper.tsx";

export interface ButtonProps extends BaseButtonProps {
    subscribersOnly?: boolean,
}

const PButtonEl = extendVariants(Button, {
    defaultVariants: {
        className: "max-sm:min-w-10 max-sm:px-0!",
        radius:    "full"
    },
});

const PButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const {isSubscribed} = useSubscription();
    const globalModal = useGlobalModal();
    const {
        domRef,
    } = useButton({
        ref,
        ...props,
    });

    if (!props.subscribersOnly || isSubscribed) {
        return <PButtonEl ref={domRef as any} {...props} />;
    }

    const propsFinal = {
        ...props,
        onPress: () => {
            globalModal.open(<PaywallWrapper onClose={() => globalModal.close()} />)
            return;
        },
    };

    return <Tooltip
        color="primary"
        content={<span className={"flex text-xs items-center gap-2"}><Icon icon="material-symbols-light:lock-sharp" /> Subscribers only</span>}
    >
        <PButtonEl ref={domRef as any} {...propsFinal} startContent={<Icon icon="material-symbols-light:lock-sharp" className="text-2xl" />} />
    </Tooltip>;

});

PButton.displayName = "PButton";

export default PButton;
